import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import ConsentCheckboxes from '../ConsentCheckboxes';
import { LEGAL_DOCS } from './legal/LegalLayout';

const APP_URL = process.env.REACT_APP_APP_URL;

export default function Register() {
  const [formData, setFormData] = useState({
    name: '', email: '', password: '', confirmPassword: '',
  });
  const [consents, setConsents] = useState({
    terms: false,
    privacy: false,
    cookie: false,
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleConsent = (code, checked) => {
    setConsents(prev => ({ ...prev, [code]: checked }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) return setError('Пароли не совпадают');
    if (formData.password.length < 6) return setError('Пароль должен быть минимум 6 символов');

    if (!consents.terms || !consents.privacy || !consents.cookie) {
      return setError('Необходимо принять условия');
    }

    setLoading(true);
    const result = await register(formData.email, formData.password, formData.name, consents);

    if (result.success) {
      // Если бэк вернул needsVerification — идём на страницу кода
      if (result.needsVerification || !result.user?.email_verified) {
        window.location.href = `/verify-email?email=${encodeURIComponent(formData.email)}`;
      } else {
        window.location.href = `${APP_URL}/catalog`;
      }
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-md p-8 max-w-md w-full">
        <h1 className="text-2xl font-bold text-center mb-6">Регистрация</h1>

        {/* {error && <div className="bg-red-50 text-red-500 p-3 rounded-xl mb-4">{error}</div>} */}
        {error && (
          <div className="bg-red-50 text-red-600 p-3 rounded-xl mb-4 text-sm">
            {error}
            {error.includes('уже зарегистрирован') && (
              <div className="mt-2">
                <Link to="/login" className="text-blue-600 hover:underline font-medium">
                  → Войти в аккаунт
                </Link>
              </div>
            )}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Имя</label>
            <input
              type="text" name="name" required
              value={formData.name} onChange={handleChange}
              className="w-full border rounded-xl px-4 py-2 focus:ring-2 focus:ring-blue-400 focus:outline-none"
              placeholder="Иван Иванов"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email" name="email" required
              value={formData.email} onChange={handleChange}
              className="w-full border rounded-xl px-4 py-2 focus:ring-2 focus:ring-blue-400 focus:outline-none"
              placeholder="your@email.com"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Пароль</label>
            <input
              type="password" name="password" required
              value={formData.password} onChange={handleChange}
              className="w-full border rounded-xl px-4 py-2 focus:ring-2 focus:ring-blue-400 focus:outline-none"
              placeholder="••••••••"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Подтвердите пароль</label>
            <input
              type="password" name="confirmPassword" required
              value={formData.confirmPassword} onChange={handleChange}
              className="w-full border rounded-xl px-4 py-2 focus:ring-2 focus:ring-blue-400 focus:outline-none"
              placeholder="••••••••"
            />
          </div>

          <ConsentCheckboxes value={consents} onChange={handleConsent} disabled={loading} />

          <button
            type="submit" disabled={loading}
            className={`w-full py-3 rounded-xl text-white transition ${
              loading ? 'bg-blue-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
            }`}
          >
            {loading ? 'Регистрация...' : 'Зарегистрироваться'}
          </button>
        </form>

        <p className="text-center mt-6 text-gray-600">
          Уже есть аккаунт?{' '}
          <Link to="/login" className="text-blue-600 hover:underline">Войти</Link>
        </p>
      </div>
    </div>
  );
}